import { render } from "./Singleocc.vue?vue&type=template&id=f517f448&scoped=true"
import script from "./Singleocc.vue?vue&type=script&lang=js"
export * from "./Singleocc.vue?vue&type=script&lang=js"

import "./Singleocc.vue?vue&type=style&index=0&id=f517f448&scoped=true&lang=css"

import exportComponent from "C:\\Entwicklung\\werbeo-app-private\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f517f448"]])

export default __exports__